module.exports = __webpack_public_path__ + "img/full6-min.f5f8fec8.png";